import { render, staticRenderFns } from "./shareBg.vue?vue&type=template&id=bdee16b4&scoped=true&"
import script from "./shareBg.vue?vue&type=script&lang=ts&"
export * from "./shareBg.vue?vue&type=script&lang=ts&"
import style0 from "./shareBg.vue?vue&type=style&index=0&id=bdee16b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdee16b4",
  null
  
)

export default component.exports